<div *ngIf="portalMenuPreferences && v10">
	<div *ngFor="let menuItem of portalMenuPreferences.PortalMenus">

		<!-- If there is only one portal, show a button -->
		<div *ngIf="menuByGroupName[menuItem.GroupName].length == 1 && !favoritesCheckbox && !favoritesFilter"
			class="pseudoPanel">
			<button mat-button
				[id]="'btn-'+ menuItem.GroupName + '-' + menuByGroupName[menuItem.GroupName][0].PortalName"
				class="pseudoHeader" [disabled]="menuByGroupName[menuItem.GroupName][0].Disabled"
				(click)="menuPortalClick(menuByGroupName[menuItem.GroupName][0]);">
				{{menuByGroupName[menuItem.GroupName][0].PortalName | translate}}
			</button>
		</div>

		<!-- If there is more than one portal, show an expansion menu -->
		<mat-expansion-panel
			*ngIf="(!favoritesFilter && menuByGroupName[menuItem.GroupName].length > 1) || favoritesCheckbox || (favoritesFilter && showfavoritesMenu(menuItem.GroupName))"
			[expanded]="menuItem.Expanded == 1" [class.mat-expansion-panel-expanded]="menuItem.Expanded == 1"
			[class.mat-expansion-panel-collapsed]="menuItem.Expanded != 1">
			<mat-expansion-panel-header (click)="savePreferences(menuItem); $event.stopPropagation();"
				[attr.tylerastid]="'pnl-'+ menuItem.GroupName" style="height:48px;">
				<mat-panel-title>
					<div style="float:left;">
						{{menuItem.GroupName | translate}}
					</div>
					<div *ngIf="menuItem.GroupName == 'Tyler Pulse'" style="margin-left:5px;float:left;width:30px;">
						<img src="./assets/images/{{menuItem.GroupIcon}}" style="max-width:24px;" />
					</div>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<button mat-menu-item [id]="'btn-'+ menuItem.GroupName + '-' + portal.PortalName"
				*ngFor="let portal of menuByGroupName[menuItem.GroupName]"
				[ngStyle]="{'display':(favoritesFilter && ((v10 && !portal.IsFavorite) || (!v10 && !portal.Selected))) ? 'none':''}"
				[disabled]="portal.Disabled" (click)="!favoritesCheckbox && menuPortalClick(portal);">
				<span *ngIf="favoritesCheckbox">
					<mat-checkbox *ngIf="!favoritesDefaults && v10"
						[id]="'chk-'+ menuItem.GroupName + '-' + portal.PortalName"
						(click)="portalCheckboxClick(portal);$event.stopPropagation()" [(ngModel)]="portal.IsFavorite">
						{{portal.PortalName | translate}}
					</mat-checkbox>
					<mat-checkbox *ngIf="!favoritesDefaults && !v10"
						[id]="'chk-'+ menuItem.GroupName + '-' + portal.PortalName"
						(click)="portalCheckboxClick(portal);$event.stopPropagation()" [(ngModel)]="portal.Selected">
						{{portal.PortalName | translate}}
					</mat-checkbox>
					<mat-checkbox *ngIf="favoritesDefaults" [id]="'chk-'+ menuItem.GroupName + '-' + portal.PortalName"
						(click)="portalCheckboxClick(portal);$event.stopPropagation()"
						[(ngModel)]="portal.isDefaultSelected">
						{{portal.PortalName | translate}}
					</mat-checkbox>
				</span>
				<span *ngIf="!favoritesCheckbox">
					{{portal.PortalName | translate}}
				</span>
			</button>
		</mat-expansion-panel>
	</div>
</div>

<div *ngIf="!v10">
	<child-menu [portals]="portals" [portalMenuPreferences]="preferences" [parentId]="0"
		[favoritesFilter]="favoritesFilter" [favoritesCheckbox]="favoritesCheckbox"
		[favoritesDefaults]="favoritesDefaults" (menuClickEvent)="childMenuClick($event)"
		(portalCheckboxClickEvent)="childPortalCheckboxClick($event)"></child-menu>
</div>